import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, EMPTY, Observable, catchError, filter, finalize, switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../../../app/features/auth/services/auth.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private hasShownTokenExpiredDialog = false;
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('provinces.open-api')) {
      const newReq = req.clone({
        headers: req.headers.delete('Authorization')
      });
      return next.handle(newReq);
    }
    const token = this.authService.getToken();
    if (token) {
      req = this.addToken(req, token);
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handle401Error(req, next);
        }
        return throwError(() => error);
      })
    )
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}` 
      }
    });
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.authService.refreshToken().pipe(
        switchMap((response: any) => {
          this.isRefreshing = false;
          this.hasShownTokenExpiredDialog = false;
          if (response && response.newAccessToken) {
            this.authService.setToken(response.newAccessToken);
            this.refreshTokenSubject.next(response.newAccessToken);
            return next.handle(this.addToken(request, response.newAccessToken));
          } else {
            this.authService.removeToken(); 
            if (!this.hasShownTokenExpiredDialog) {
              this.hasShownTokenExpiredDialog = true;
              this.router.navigate(['/']);
            }
            return EMPTY;
          }
        }),
        catchError((err: any) => {
          this.isRefreshing = false;
          this.authService.removeToken();
          if (!this.hasShownTokenExpiredDialog) {
            this.hasShownTokenExpiredDialog = true;
            this.router.navigate(['/']);
          }
          return EMPTY;
        }),
        finalize(() => {
          this.isRefreshing = false;
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(token => {
          return next.handle(this.addToken(request, token));
        })
      );
    }
  }
};
